<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import Button from './Button.vue'
import userStore from '@/modules/users/store'
import { CreateElement } from 'vue'
import { EntityReference } from '@/modules/users/FollowedEntities'
import { lassoxPortalUrl } from '@/lasso-urls'

@Component({
  components: {
    Button,
  },
})

export default class FollowButton extends Vue {
  @Prop({ type: String, required: true })
  readonly lassoId!: string

  @Prop({ type: String, required: true })
  readonly name!: string

  promise: Promise<void> | null = null

  get entity (): EntityReference {
    return { lassoId: this.lassoId, name: this.name }
  }

  get user () {
    return userStore.user
  }

  get following () {
    return this.user && this.lassoId in this.user.followedEntities.byLassoId
  }

  get disabled () {
    return !!this.promise
  }

  onClick () {
    if (!this.user) {
      const trackingEventName = [...this.$el.classList]
        .find(className => className.includes('plausible-event-name='))
        ?.replace('plausible-event-name=', '') || ''

      if (!trackingEventName)
        console.log('Plausible class not found, signup cannot be tracked')

      userStore.showLoginToFollowDialog({
        entity: this.entity,
        trackingEventName,
        lassoxIntro: {
          title: 'Følg firmaer og personer',
          text: 'Opret en profil og få større indsigt i dansk erhvervsliv. Du får bl.a. adgang til nye værktøjer og flere oplysninger om regnskaber, historik og ejerforhold – alt sammen helt gratis.',
          image: require('@/assets/img/signup-dialog-follow.png'),
          color: 'pink'
        }
      })
      return
    }

    location.href = `${lassoxPortalUrl}/${this.lassoId}`

    // this.promise = !this.following
    //   ? this.user.followEntities([ this.entity ])
    //   : this.user.unfollowEntities([ this.entity ])

    // this.promise.then(() => this.promise = null)
  }

  render (createElement: CreateElement) {
    const scopedSlot = this.$scopedSlots.default?.({
      following: this.following,
      disabled: this.disabled,
      onClick: this.onClick,
    }) ?? null

    if (scopedSlot?.length === 1) return scopedSlot[0]

    return createElement(Button, {
      class: 'follow-button',
      props: {
        theme: this.following ? 'white' : 'peach',
        outlined: this.following,
        disabled: this.disabled,
        label: this.following ? 'Følger' : 'Følg',
      },
      on: {
        click: this.onClick,
      },
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@shared/style/global.scss';

.follow-button {}
</style>
